import styled from "styled-components";
import { Label, HelperText as DefaultHelperText } from "../styles";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  opacity: ${p => (p.disabled ? 0.5 : 1)};
  pointer-events: ${p => (p.disabled ? "none" : "auto")};
`;

export const Input = styled.input`
  background-color: #ffffff;
  border: 1px solid #d6d6d6;
  border-radius: 4px;
  box-sizing: border-box;
  height: 40px;
  color: #797b81;
  font-size: 14px;
  font-weight: 400;
  padding: 0px 16px;

  &:focus {
    border: 1px solid #808cec;
    color: #676a73;
    outline: none;
  }

  &::-webkit-input-placeholder {
    color: #797b81;
    font-weight: 400;
  }

  &::-moz-placeholder {
    color: #797b81;
    font-weight: 400;
  }

  &:-ms-input-placeholder {
    color: #797b81;
    font-weight: 400;
  }

  &:-moz-placeholder {
    color: #797b81;
    font-weight: 400;
  }
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  opacity: ${p => (p.disabled ? 0.5 : 1)};
  pointer-events: ${p => (p.disabled ? "none" : "auto")};
  > div:first-child {
    margin-right: 8px;

    label {
      display: flex;
    }

    rect {
      fill: ${props => (props.isChecked ? "#4957d2" : null)};
    }
  }
`;

export const CheckboxLabel = styled(Label)`
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  opacity: ${p => (p.disabled ? 0.5 : 1)};
`;

export const HelperText = styled(DefaultHelperText)`
  margin-bottom: 0px;
  margin-top: 08px;
`;

export const LabelSubText = styled.span`
  color: #797b81;
`;
